import { ApiItem } from './api-item';

export class Item {
    public readonly id: number;
    public readonly uniqueId: string;
    public readonly title: string;

    constructor(
        mapItem: ApiItem,
        uniqueId?: string,
    ) {
        this.uniqueId = uniqueId ?? String(mapItem.id);
        this.id = mapItem.id;
        this.title = mapItem.title;
    }
}
